import { render } from "./Number.vue?vue&type=template&id=2613e3f1"
import script from "./Number.vue?vue&type=script&lang=js"
export * from "./Number.vue?vue&type=script&lang=js"
script.render = render

export default script